<Navbar />

<div :class="[wrapper_class, 'd-flex', 'aic-mobile-page', 'aic-create-page', 'aic-mobile-content', 'workspace-hub-page']">
  <Sidebar />

  <main class="hero-section w-100 aic-safe-bottom workspace-hub-main">
    <section class="workspace-hub-shell w-100 mx-0">
      <nav class="workspace-tab-strip d-flex w-100 mb-4 p-2 overflow-auto border rounded-4" aria-label="Workspace categories">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          class="workspace-tab flex-shrink-0 border-0 text-nowrap fw-bold"
          :class="{ active: active_tab === tab.value }"
          type="button"
          @click="active_tab = tab.value"
        >
          {{ tab.label }}
        </button>
      </nav>

      <div v-if="active_tab === 'home'" class="workspace-home-panel w-100">
        <header class="workspace-section-head mb-4 text-start">
          <h1 class="mb-1">My Workspace</h1>
          <p class="mb-0">Personal workspace with all tools</p>
        </header>

        <div
          v-if="platform_access_loading && allowed_app_keys.length === 0"
          class="workspace-empty-state d-flex flex-column align-items-center justify-content-center bg-white border text-center"
        >
          <div class="workspace-empty-icon d-inline-flex align-items-center justify-content-center">
            <i class="fa-solid fa-table-cells-large" aria-hidden="true"></i>
          </div>
          <h2 class="mb-2">Loading platforms</h2>
          <p class="mb-0">Preparing your workspace applications.</p>
        </div>

        <div
          v-else-if="allowed_app_keys.length === 0"
          class="workspace-empty-state d-flex flex-column align-items-center justify-content-center bg-white border text-center"
        >
          <div class="workspace-empty-icon d-inline-flex align-items-center justify-content-center">
            <i class="fa-solid fa-table-cells-large" aria-hidden="true"></i>
          </div>
          <h2 class="mb-2">No platforms assigned yet</h2>
          <p class="mb-0">You don't have access to any platforms at the moment. Contact your administrator to request access.</p>
        </div>

        <div v-else class="workspace-card-grid w-100">
          <article
            v-for="card in available_workspace_cards"
            :key="card.key"
            class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start"
          >
            <div class="workspace-card-top d-flex align-items-center min-w-0">
              <div class="workspace-platform-icon d-inline-flex align-items-center justify-content-center flex-shrink-0" :class="card.tone">
                <img :src="card.image" :alt="card.name" />
              </div>

              <div class="workspace-card-title min-w-0 text-start">
                <h2 class="mb-1">{{ card.name }}</h2>
                <p class="mb-0">{{ card.category }}</p>
              </div>
            </div>

            <p class="workspace-card-description mb-0 text-start">{{ card.description }}</p>

            <button
              class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100"
              type="button"
              @click="handle_workspace_card_action(card)"
            >
              {{ card.cta }} <span aria-hidden="true">&rarr;</span>
            </button>
          </article>
        </div>
      </div>

      <div v-else class="workspace-content workspace-detail-panel w-100">
        <component :is="active_component" />
      </div>
    </section>
  </main>
</div>
